import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'

import Card from '@/checkout-instore-legacy/components/Commons/Elements/Card'
import CardTitle from '@/checkout-instore-legacy/components/Commons/Elements/CardTitle'
import Tag from '@/checkout-instore-legacy/components/Commons/Tag'
import { genericImportantError } from '@/checkout-instore-legacy/utils/EventHelper'

const CustomCard = ({ title, data }) => {
  if (isEmpty(title) || isEmpty(data)) {
    genericImportantError('customer-profile-error', {
      title,
      data,
      errorMessage: 'Invalid customCard context',
    })
    return null
  }

  return (
    <Card className="mb5 pa0">
      <div className="f3 fw2 pv5">
        <div className="ph5">
          <CardTitle text={title} />
        </div>
        {data.map((dataEntry, index) => {
          return (
            <div
              key={dataEntry.id || index}
              className={`f0 fw4 ${index > 0 ? 'bt b--moon-gray mt5 pt5' : ''}`}
            >
              {dataEntry.tags &&
                dataEntry.tags.map((tag, tagIndex) => (
                  <Tag
                    key={tag.id || tagIndex}
                    className={`relative ${tagIndex === 0 ? 'ml5' : 'ml4'}`}
                    fontSize="small"
                    innerClassName="dark-gray bg-lighter-gray"
                    {...tag}
                  />
                ))}
              {dataEntry.contents.map((content, contentIndex) => (
                <div
                  key={content.id || contentIndex}
                  className="f5 middle-gray mt4 ml5"
                  {...content.props}
                >
                  {content.text}
                </div>
              ))}
            </div>
          )
        })}
      </div>
    </Card>
  )
}

CustomCard.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
}

export default CustomCard
